import { Table, message } from "antd";
import { ColumnsType } from "antd/es/table";
import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import {
  useDeleteDirectionMutation,
  useGetDirectionMutation,
} from "src/app/services/finance";
import { IDirection } from "src/app/services/finance/type";
import { useTypedSelector } from "src/app/store";
import PaginationFilter from "src/components/filter/PaginationFilter";
import TableActions from "src/components/view/TableActions";
import ContentTop from "src/layout/content/ContentTop";
import { handleMakeUrl } from "src/utils";
import { directionColumns } from "./constants";
import AddDirection from "./components/AddDirection";
import { useTranslation } from "react-i18next";

function DirectionPage() {
  const { t } = useTranslation();
  //Get section
  const [searchParams] = useSearchParams();
  const [getDirection, { data: directionsData, isLoading }] =
    useGetDirectionMutation();
  const { directions } = useTypedSelector((state) => state.direction);
  const handleGet = () => {
    let url = handleMakeUrl(searchParams);
    getDirection(url);
  };
  useEffect(() => {
    handleGet();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchParams]);

  //Delete section
  const [deleteDirection, { isSuccess: deleteStatus }] =
    useDeleteDirectionMutation();
  useEffect(() => {
    if (deleteStatus) {
      handleGet();
      message.success("Item deleted successfully!");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [deleteStatus]);

  //Edit section
  const [editableData, setEditableData] = useState<IDirection>();

  const onEdit = (val: number) => {
    let obj = directions?.find((el) => el.id === val);
    if (obj) setEditableData(obj);
  };

  //Table section
  const columns: ColumnsType<IDirection> = [
    ...directionColumns(t),
    {
      title: t("common.actions"),
      dataIndex: "key",
      key: "key",
      width: 90,
      fixed: "right",
      render: (key) => (
        <TableActions
          onDelete={() => deleteDirection(key)}
          onEdit={() => onEdit(key)}
        />
      ),
    },
  ];

  return (
    <div>
      <ContentTop>
        <AddDirection
          handleGet={handleGet}
          editableData={editableData}
          setEditableData={setEditableData}
        />
      </ContentTop>

      <Table
        columns={columns}
        dataSource={directions}
        scroll={{ x: 800 }}
        pagination={false}
        loading={isLoading}
      />
      {directionsData && <PaginationFilter total={directionsData?.count} />}
    </div>
  );
}

export default DirectionPage;
